/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description': 'Pide ayuda a tu equipo o administrador.',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title': 'No hemos podido obtener ningún resultado para esta búsqueda'
};